import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { defaultRouteFor, hasAnyRole, UserRole } from '../helpers/user-roles';

/**
 * Permite el acceso solo si el usuario tiene alguno de los roles indicados.
 * Es una restricción de UX: la autorización real la hace el backend.
 */
export const roleGuard = (...roles: UserRole[]): CanActivateFn => (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    authService.redirectUrl = state.url;
    return router.createUrlTree(['/auth/login']);
  }

  if (hasAnyRole(authService.userLogged$(), roles)) {
    return true;
  }

  // Logueado pero sin permisos: vuelve a su ruta de inicio según rol.
  return router.createUrlTree([defaultRouteFor(authService.userLogged$())]);
};
